<template>
  <div class="homepage-ships">
    <h2 class="comm-title">皇家游轮体验</h2>
    <h3 class="comm-subtitle"><span class="num">26</span>艘海上移动城堡</h3>
<!--    <div class="ships-wrapper">-->
<!--      <ul class="ships-nav">-->
<!--        <template v-for="(item, i) in ships">-->
<!--          <li-->
<!--            v-if="item.id === 3 || item.id === 7"-->
<!--            :key="i"-->
<!--            class="swiper-slide"-->
<!--            :class="{ active: currentShipIndex == i }"-->
<!--            @click="changeShipIndex(i, item.shipCode)"-->
<!--          >-->
<!--            <div class="ship-image">-->
<!--              <img class="sw-img1" :src="item.shipENImageSelectedMobile" alt="" />-->
<!--              <img class="sw-img2" :src="item.shipENImageMobile" alt="" />-->
<!--            </div>-->
<!--            <div class="ships-name">{{ item.shipCNName }}</div>-->
<!--          </li>-->
<!--        </template>-->
<!--      </ul>-->
<!--    </div>-->

    <div class="ships-wrapper" style="margin: 0 auto 10px">
      <ul class="ships-nav-blue">
        <template v-for="(item, i) in ships">
          <li
              v-if="item.id === 3 || item.id === 7"
              :key="i"
              class="swiper-slide"
              :class="{ active: currentShipIndex == i }"
              @click="changeShipIndex(i, item.shipCode)"
          >
            <div class="ships-name">{{ item.shipCNName }}</div>
            <div class="ship-image">
              <img class="sw-img1" :src="item.shipENImageSelectedMobile" alt="" />
              <img class="sw-img2" :src="item.shipENImageMobile" alt="" />
            </div>
          </li>
        </template>
      </ul>
    </div>

<!--    <div class="royal-ship-banner">-->
<!--      <img src="https://resource.rcclchina.com.cn/Home/home_banner_SC_mb.jpg" />-->
<!--    </div>-->

    <div
      v-for="(ship, i) in ships"
      :key="i"
      class="ships-content"
      :class="{ active: currentShipIndex == i }"
    >
<!--      <img-->
<!--        class="ships-playBtn"-->
<!--        :src="ship.mobileBackgroundImage"-->
<!--        alt=""-->
<!--        @click="playVideo('shipVideo_' + i, ship.shipCode)"-->
<!--      />-->
      <template v-if="ship.id === 3 || ship.id === 7">
        <video
          class="ships-video"
          :ref="'shipVideo_' + i"
          :src="ship.pcVideo"
          v-if="false"
          controls
          playsinline="true"
          x-webkit-airplay="true"
          x5-video-player-type="h5"
          x5-videoplayer-fullscreen="true"
          webkit-playsinline="true"
          @pause="pauseVideo('shipVideo_' + i)"
        ></video>
        <div class="ships-imgs">
          <ul class="ships-superImgs">
            <li
              v-for="(experienceItem, j) in getExperienceItemsByShipId(ship.id)"
              :key="j"
              :class="{ active: j == currentItemIndex }"
            >
              <a
                v-if="
                  experienceItem.mobileLink &&
                  experienceItem.mobileLink.length > 0
                "
                class="external"
                @click="goToShipPage(experienceItem.mobileLink, experienceItem.code, ship.shipCode)"
                target="_blank"
              >
                <img :src="experienceItem.mobileImage" alt="" />
              </a>
              <img
                v-if="
                  !experienceItem.mobileLink ||
                  experienceItem.mobileLink.length == 0
                "
                :src="experienceItem.mobileImage"
                alt=""
              />
            </li>
          </ul>
        </div>
      </template>
    </div>
    <div></div>
  </div>
</template>


<script>
import _ from "lodash";
import { gioAdsTracking } from "@/utilities/tools";
export default {
  name: "RoyalShip",
  props: {
    homeShip: {
      type: Object,
      default: () => {
        return {};
      },
    },
  },
  data() {
    return {
      shipExperienceIds: [],
      currentShipIndex: 0,
      currentItemIndex: 0
    };
  },
  methods: {
    getExperienceItemsByShipId(shipId) {
      let experienceItems = this.homeShip.homeExperienceItemViewModels.filter(
        (r) => r.shipId == shipId
      );
      experienceItems = _.orderBy(experienceItems, "mobileSeq", "asc");
      return experienceItems;
    },
    changeShipIndex(index, shipCode) {
      this.currentShipIndex = index;
			gioAdsTracking({
				"adsType": "sp",
				"spCode": shipCode
			});
    },
    onExperienceItemMouseEnter(index) {
      this.currentItemIndex = index;
    },
    goToShipPage(link, expCode, shipCode) {
			gioAdsTracking({
				"adsType": "sp",
				"spCode": shipCode,
				"spCat": expCode,
				"desUrl": process.env.VUE_APP_BASE_URL + link
			});
      window.location.href = process.env.VUE_APP_BASE_URL + link;
    },
    playVideo(ref, shipCode) {
      const video = this.$refs[ref][0];
      try {
        // video.webkitRequestFullScreen();
        // video.requestFullscreen();
        if (video.webkitEnterFullscreen || video.enterFullScreen) {
          video.webkitEnterFullscreen && video.webkitEnterFullscreen();
          video.enterFullScreen && video.enterFullScreen();
        }
      } catch (error) {
        console.error(error);
      }
      video.play();
      video.style.display = "block";
			gioAdsTracking({
				"adsType": "sp",
				"spCode": shipCode,
				"spVideo": 1
			});
    },
    pauseVideo(ref) {
      const video = this.$refs[ref][0];
      if (video) {
        video.pause();
        video.style.display = "none";
      }
    },
  },
  computed: {
    ships() {
      return this.homeShip.homeRoyalShipItemViewModels;
    },
  },
};
</script>

<style scoped>
* {
  margin: 0;
  padding: 0;
  list-style: none;
  
  text-transform: uppercase;
}
img {
  display: block;
}

.comm-title {
  width: 100%;
  text-align: center;
  font-size: 23px;
  font-weight: bold;
  color: #282b2c;
  line-height: 33px;
}
.comm-subtitle {
  width: 100%;
  font-size: 12px;
  font-weight: 400;
  color: #282b2c;
  line-height: 22px;
  text-align: center;
  margin-bottom: 15px;
}

/*视频相关*/
video.dest-video,
video.dest-clickBtn,
video.ships-video {
  width: 100%;
  height: 100%;
  position: absolute;
  left: 0;
  top: 0;
  z-index: 9999;
}
/*游轮体验*/
.homepage-ships {
  width: 100%;
  overflow: hidden;
  margin-bottom: 26px; /*会注释*/
}
.homepage-ships .swiper-container {
  padding-bottom: 0px;
}
.homepage-ships .comm-subtitle .num {
  font-weight: bold;
  color: #ffa70d;
}
.homepage-ships .ships-wrapper {
  width: 345px;
  overflow: hidden;
  margin: 0 auto 16px;
}
.homepage-ships .ships-nav {
  /* width: 460px; */
  height: 42px;
  overflow: scroll;
  display: flex;
  justify-content: center;
  //padding-right: 30px;
}

.homepage-ships .ships-nav::-webkit-scrollbar {
  display: none;
}

.homepage-ships .ships-nav li.swiper-slide {
  width: 80px !important;
  margin-right: 16px;
}
.homepage-ships .ships-nav li {
  width: 80px;
  height: 42px;
}

.homepage-ships .ships-nav li .ship-image {
  width: 82px;
  height: 9px;
  margin: 0 auto 3px;
}

.homepage-ships .ships-nav li img {
  width: 100%;
}

.homepage-ships .ships-nav li img.sw-img1 {
  display: none;
}
.homepage-ships .ships-nav li .ships-name {
  font-size: 12px;
  font-weight: 400;
  color: #747d80;
  text-align: center;
}
.homepage-ships .ships-nav li.active {
  border-bottom: 3px solid #0073bb;
}
.homepage-ships .ships-nav li.active img.sw-img1 {
  display: block;
}
.homepage-ships .ships-nav li.active img.sw-img2 {
  display: none;
}
.homepage-ships .ships-nav li.active .ships-name {
  color: #0073bb;
}
.homepage-ships .ships-content {
  margin-bottom: 15px;
  display: none;
  position: relative;
}
.homepage-ships .ships-content.active {
  display: block;
}
.homepage-ships .ships-content > img {
  margin-bottom: 12px;
  width: 375px;
}

.homepage-ships .ships-content .ships-imgs > .ships-superImgs li:first-child,
.homepage-ships
  .ships-content
  .ships-imgs
  > .ships-superImgs
  li:first-child
  img {
  width: 345px;
  /* margin-bottom: 5px; */
}

.homepage-ships .ships-content .ships-imgs > .ships-superImgs li:nth-child(6),
.homepage-ships
  .ships-content
  .ships-imgs
  > .ships-superImgs
  li:nth-child(6)
  img {
  width: 345px;
}

.homepage-ships .ships-content .ships-imgs > .ships-superImgs {
  width: 100%;
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  padding: 0px 15px;
}
.homepage-ships .ships-content .ships-imgs > .ships-superImgs li {
  width: 172px;
  overflow: hidden;
  margin-bottom: 1px;
  position: relative;
}
.homepage-ships .ships-content .ships-imgs > .ships-superImgs li .mask {
  /* background: rgba(0,0,0,.3); */
  position: absolute;
  left: 0;
  top: 0;
  right: 0;
  bottom: 0;
  text-align: center;
}
.homepage-ships
  .ships-content
  .ships-imgs
  > .ships-superImgs
  li
  .mask
  .mask-text {
  font-size: 17px;
  font-weight: bold;
  color: #fff;
  margin-top: 18px;
  text-transform: uppercase;
  text-align: center;
  text-shadow: 0px 0px 13px rgba(126, 30, 24, 0.004);
  -moz-transform: matrix(1.357681515166, 0, 0, 1.35768151516601, 0, 0);
  -webkit-transform: matrix(1.357681515166, 0, 0, 1.35768151516601, 0, 0);
  -ms-transform: matrix(1.357681515166, 0, 0, 1.35768151516601, 0, 0);
}

.homepage-ships
  .ships-content
  .ships-imgs
  > .ships-superImgs
  li:nth-child(1)
  .mask
  .mask-text,
.homepage-ships
  .ships-content
  .ships-imgs
  > .ships-superImgs
  li:nth-child(6)
  .mask
  .mask-text {
  margin-top: 30px;
}

.homepage-ships
  .ships-content
  .ships-imgs
  > .ships-superImgs
  li
  .mask
  .mask-parah {
  font-size: 12px;
  font-weight: 100;
  color: #fff;
}
.homepage-ships .ships-content .ships-imgs > .ships-superImgs li img {
  width: 183px;
  height: auto;
}
.btn-link {
  display: block;
  width: 345px;
  height: 45px;
  border: 1px solid #0073bb;
  line-height: 45px;
  text-align: center;
  color: #0073bb;
  margin: 0 auto;
}
.royal-ship-banner {
  width: 100%;
  margin-bottom: 12px;
}
.royal-ship-banner > img {
  display: block;
  width: 100%;
}

.homepage-ships .ships-nav-blue {
  height: 64px;
  overflow: scroll;
  display: flex;
  justify-content: center;
}

.homepage-ships .ships-nav-blue::-webkit-scrollbar {
  display: none;
}

.homepage-ships .ships-nav-blue li.swiper-slide {
  flex: 1;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-flow: column;
  gap: 2px;
}
.homepage-ships .ships-nav-blue li {
  height: 64px;
  background-color: #f8f8f8;
}

.homepage-ships .ships-nav-blue li .ship-image {
  margin-top: 2px;
}

.homepage-ships .ships-nav-blue li img {
  height: 9px;
}

.homepage-ships .ships-nav-blue li img.sw-img1 {
  display: none;
}
.homepage-ships .ships-nav-blue li .ships-name {
  font-size: 12px;
  line-height: 1;
  font-weight: 500;
  color: #0f005a;
  text-align: center;
}
.homepage-ships .ships-nav-blue li.active {
  background-color: #006dbb;
}
.homepage-ships .ships-nav-blue li.active img.sw-img1 {
  display: block;
}
.homepage-ships .ships-nav-blue li.active img.sw-img2 {
  display: none;
}
.homepage-ships .ships-nav-blue li.active .ships-name {
  color: #FFFFFF;
}
</style>
